<script lang="ts">
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import { years, validity } from "../options/document.options";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    const onSubmit = (): void => serviceProvider.documentService.submitSearch();

    const onCategoryChanged = (): void => {
        if (dataProvider.isWo() && dataProvider.platnost === "") {
            dataProvider.platnost = "true";
        }

        onSubmit();
    };

    const onRokChanged = (): void => {
        if (dataProvider.rok === "") {
            dataProvider.rok = "vse";
        }

        onSubmit();
    };

    const onPlatnostChanged = (): void => {
        if (dataProvider.platnost === "") {
            dataProvider.platnost = "vse";
        }

        onSubmit();
    };

    const onUtvarChanged = (): void => {
        if (dataProvider.utvar === "") {
            dataProvider.utvar = "vse";
        }

        onSubmit();
    };

    const onReset = (): void => {
        dataProvider.resetFilter();
        serviceProvider.documentService.submitSearch();
        dataProvider = dataProvider;
    };
</script>

<form
    class="bno-hero-banner__form"
    aria-label="Vyhledávání dokumentů"
    on:submit|preventDefault={onSubmit}
    on:reset|preventDefault={onReset}
>
    <div class="bno-form-control" style="max-width: 230px">
        <div class="bno-select">
            <select
                name="kategorie"
                id="select-kategorie"
                aria-required="false"
                aria-disabled="false"
                bind:value={dataProvider.kategorie}
                on:change={onCategoryChanged}
            >
                <option value="">Všechny dokumenty</option>

                {#each dataProvider.categories as option}
                    <option value={String(option.slug)}>{option.name}</option>
                {/each}
            </select>
            <label
                class="bno-form-control__label u-sr-only"
                for="select-kategorie"
            >
                Kategorie dokumentu
            </label>
        </div>
    </div>

    {#if dataProvider.isWo()}
        <div class="bno-form-control" style="max-width: 90px">
            <div class="bno-select">
                <select
                    name="rok"
                    id="select-rok"
                    aria-required="false"
                    aria-disabled="false"
                    bind:value={dataProvider.rok}
                    on:change={onRokChanged}
                >
                    {#if dataProvider.rok === "vse"}
                        <option value="vse">Rok</option>
                    {:else}
                        <option value="">Rok</option>
                    {/if}

                    {#each years() as option}
                        <option value={String(option.id)}>{option.name}</option>
                    {/each}
                </select>
                <label
                    class="bno-form-control__label u-sr-only"
                    for="select-rok"
                >
                    Rok
                </label>
            </div>
        </div>

        <div class="bno-form-control" style="max-width: 140px">
            <div class="bno-select">
                <select
                    name="platnost"
                    id="select-platnost"
                    aria-required="false"
                    aria-disabled="false"
                    bind:value={dataProvider.platnost}
                    on:change={onPlatnostChanged}
                >
                    {#if dataProvider.platnost === "vse"}
                        <option value="vse">Platnost</option>
                    {:else}
                        <option value="">Platnost</option>
                    {/if}

                    {#each validity as option}
                        <option value={String(option.id)}>{option.name}</option>
                    {/each}
                </select>
                <label
                    class="bno-form-control__label u-sr-only"
                    for="select-platnost"
                >
                    Platnost
                </label>
            </div>
        </div>
    {/if}

    {#if dataProvider.isWo() === false}
        <div class="bno-form-control" style="max-width: 230px">
            <div class="bno-select">
                <select
                    name="utvar"
                    id="select-utvar"
                    aria-required="false"
                    aria-disabled="false"
                    bind:value={dataProvider.utvar}
                    on:change={onUtvarChanged}
                >
                    {#if dataProvider.utvar === "vse"}
                        <option value="vse">Útvar</option>
                    {:else}
                        <option value="">Útvar</option>
                    {/if}

                    {#each dataProvider.documentFolders as option}
                        <option value={String(option.slug)}
                            >{option.name}</option
                        >
                    {/each}
                </select>
                <label
                    class="bno-form-control__label u-sr-only"
                    for="select-utvar"
                >
                    Útvar
                </label>
            </div>
        </div>
    {/if}

    <div class="bno-search bno-search--compact">
        <div class="bno-search__inner">
            <div class="bno-form-control">
                <input
                    id="input-search"
                    bind:value={dataProvider.searchString}
                    class="bno-form-control__input bno-form-control__input--standalone"
                    type="text"
                    aria-required="false"
                    aria-disabled="false"
                    autocomplete="off"
                    placeholder={dataProvider.placeholder}
                />
                <label
                    class="bno-form-control__label u-sr-only"
                    for="input-search"
                >
                    Hledat
                </label>
            </div>
            <button
                class="bno-toggle bno-toggle--plain"
                type="submit"
                aria-label="Odeslat formulář vyhledávání"
            >
                <span class="bno-icon bno-icon--search" />
            </button>
        </div>
    </div>

    <!-- {#if dataProvider.isFilterActive}
        <button class="bno-button bno-button--secondary bno-button--opaque" type="reset" style="min-width: fit-content">
            {dataProvider.ctaReset}
        </button>
    {/if} -->
</form>
